import React from 'react';
import Title from '../../../../../@casino/ui/title';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from '../../../../../@casino/useRouter';
import { useFormik, FormikContext } from "formik";
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import { setPostUpdateMessanger } from '../../store/thunk/setPostUpdateMessanger';
import { setGetViewMessanger } from '../../store/thunk/setGetViewMessanger';

const useStyles = makeStyles(() => ({
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '32%',
    },
    mt0: {
        marginTop: 0
    },
    wrapActiveBonus: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '70%'
    },
}))

const MessangerEdit = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const classes = useStyles();
    const { id } = router.query;

    React.useEffect(() => {
        dispatch(setGetViewMessanger({
            id
        }))
    }, [id])

    const onSubmit = (store) => {
        dispatch(setPostUpdateMessanger(store))
    }

    const initialValues = useSelector(state => state.messanger.view);
    const formik = useFormik({ onSubmit, initialValues, enableReinitialize: true });

    return (
        <div style={{ padding: '0 20px' }}>
            <Title
                label="Редактирование месенджера"
                labelBtn="Назад"
                button={() => router.history.push('/settings/messanger')}
            />
            <div style={{
                padding: 20,
                background: '#1b2039',
                borderRadius: 8,
            }}>
                <FormikContext.Provider value={formik}>
                    <form onSubmit={formik.handleSubmit}>
                        <label htmlFor="type" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                            <span className={classes.helper}>Тип мессенджера</span>
                            <input
                                type="text"
                                name="type"
                                id="type"
                                className={classes.text}
                                value={formik.values.type}
                                onChange={(v) => formik.setFieldValue('type', v.target.value)}
                            />
                        </label>
                        <label htmlFor="link" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                            <span className={classes.helper}>Ссылка</span>
                            <input
                                type="text"
                                name="link"
                                id="link"
                                className={classes.text}
                                value={formik.values.link}
                                onChange={(v) => formik.setFieldValue('link', v.target.value)}
                            />
                        </label>
                        <label htmlFor="select" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                            <span className={classes.helper}>Выбрать на каком языке будет показываться</span>
                            <select style={{ height: '34px' }}
                                className={classes.text}
                                value={formik.values.language}
                                onChange={(v) => formik.setFieldValue('language', v.target.value)}
                            >
                                <option value="" style={{ display: 'none' }}>Выбрать язык</option>
                                <option value="RU">Россия</option>
                                <option value="US">США</option>
                                <option value="GE">Грузия</option>
                                <option value="TR">Турция</option>
                                <option value="IR">Иран</option>
                                <option value="IT">Италия</option>
                                <option value="MD">Мадрид</option>
                                <option value="PK">Пакистан</option>
                                <option value="GR">Греция</option>
                                <option value="AZ">Азербайджан</option>
                            </select>
                        </label>
                        <label htmlFor="link" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                            <span className={classes.helper}>website</span>
                            <input 
                                type="text" 
                                name="link" 
                                id="link" 
                                className={classes.text}
                                value={formik.values.website} 
                                onChange={(v) => formik.setFieldValue('website', v.target.value)}
                            />
                        </label>
                        <div>
                            <span
                                onClick={() => formik.submitForm()}
                                style={{
                                    color: '#141b33',
                                    cursor: 'pointer',
                                    padding: '10px',
                                    background: '#ffc324',
                                    borderRadius: '4px',
                                }}
                            >
                                Сохранить
                            </span>
                        </div>
                    </form>
                </FormikContext.Provider>
            </div>
        </div>
    )
}

export default MessangerEdit;